var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg18PxCircleDollar = function Svg18PxCircleDollar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    "aria-hidden": "true"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 7.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.817 6.951c-.394-.933-1.183-1.144-1.779-1.144-.554 0-2.01.295-1.875 1.692.094.981 1.019 1.346 1.827 1.49s1.981.452 2.01 1.635c.024 1-.875 1.683-1.962 1.683-1.038 0-1.76-.404-2.038-1.317M9 4.75v1.057M9 12.307v.943"
  }))));
};
export default Svg18PxCircleDollar;